import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { CommonTableFrame } from '../../../components/common/CommonTableFrame';
import { LoadingContainer } from '../../../components/common/LoadingContainer';
import { useUserContext } from '../../../context/UserContext';
import { getFormattedDateString } from '../../../helpers/utils';
import transactionAPI from '../../../services/API/transactions';

export const TransactionsList = (props) => {
  const {
    setLoadingTransactions,
    transactionsData,
    loadingTransactions,
    loadTransactionList,
    isSM,
  } = props;
  const columns = [
    {
      accessor: 'id',
      Header: 'ID NUMBER',
      Cell: (rowData) => {
        const { id } = rowData.row.original;
        return <span>{`#${id}` || '--'}</span>;
      },
      headerProps: {
        style: {
          fontWeight: 400,
          fontSize: isSM ? 12 : 14,
          paddingTop: 16,
          paddingBottom: 16,
          width: 160,
          maxWidth: 160,
        },
      },
      cellProps: {
        style: {
          paddingTop: 24,
          paddingBottom: 24,
          width: 160,
          maxWidth: 160,
          fontSize: isSM ? 12 : 14,
          fontWeight: 400,
        },
      },
    },
    {
      accessor: 'amount',
      Header: 'AMOUNT',
      headerProps: {
        style: {
          fontWeight: 400,
          fontSize: isSM ? 12 : 14,
          paddingTop: 16,
          paddingBottom: 16,
          width: 160,
          maxWidth: 160,
        },
      },
      cellProps: {
        style: {
          paddingTop: 24,
          paddingBottom: 24,
          fontSize: isSM ? 12 : 14,
          fontWeight: 400,
          width: 160,
          maxWidth: 160,
        },
      },
    },
    {
      accessor: 'description',
      Header: 'DESCRIPTION',
      headerProps: {
        style: {
          fontWeight: 400,
          fontSize: isSM ? 12 : 14,
          paddingTop: 16,
          paddingBottom: 16,
          width: 600,
          maxWidth: 600,
        },
      },
      sortType: 'string',
      cellProps: {
        style: {
          paddingTop: 24,
          paddingBottom: 24,
          width: 600,
          maxWidth: 600,
          fontSize: isSM ? 12 : 14,
          fontWeight: 400,
        },
      },
    },
    {
      accessor: 'transaction_date',
      Header: 'DATE',
      headerProps: {
        style: {
          fontWeight: 400,
          fontSize: isSM ? 12 : 14,
          paddingTop: 16,
          paddingBottom: 16,
        },
      },
      Cell: (rowData) => {
        const { transaction_date } = rowData.row.original;
        return <span>{getFormattedDateString(transaction_date)}</span>;
      },
      cellProps: {
        style: {
          paddingTop: 24,
          paddingBottom: 24,
          fontSize: isSM ? 12 : 14,
          fontWeight: 400,
        },
      },
    },
  ];

  return (
    <CommonTableFrame
      title='Transaction History'
      allowSearch={false}
      handleRefresh={() => {
        if (loadTransactionList) {
          setLoadingTransactions(true);
          loadTransactionList();
        }
      }}
      isLoading={loadingTransactions}
      columns={columns}
      data={transactionsData}
      path=''
    />
  );
};
